import Icon from 'atomic/icon/icon';
import Rating from 'atomic/rating/rating';
import classNames from 'classnames';
import DealerOpinionsInterface, { BadgeType } from 'interfaces/dealer-opinions.interface';
import React, { ReactElement } from 'react';
import ProducerInterface from '../../../../../interfaces/producer.interface';
import DealerBadges from './components/dealer-badges';
import { isProductRateZero } from 'modules/product/views/components/product-offers/components/rates/helpers/is-product-rate-zero';

import './product-offer-dealer-info.scss';

const OfferDealerInfo: React.FC<{
    className?: string;
    title: string;
    rates?: boolean;
    dealer: {
        id: number;
        name: string;
        authorized: {
            logo: string | null;
        };
        badge?: {
            name: string;
            type: BadgeType;
        };
        producer?: ProducerInterface;
        opinions: DealerOpinionsInterface | null;
    };
    badges: {
        fastPayment?: boolean;
        isOpineoQuality?: boolean;
        isQuality?: boolean;
        inPost?: boolean;
        freeDelivery?: boolean;
        delivery24?: boolean;
        promoText?: string;
    };

}> = ({ className, dealer, badges, rates, title }): ReactElement => {
    return (
        <div className={classNames({
            'dealer-info': true,
            [String(className)]: Boolean(className)
        })}
        >
            <div className="dealer-info__header">

                <div className="dealer-info__header-dealer">
                    <span className="dealer-name">{dealer.name}</span>
                    <Rating className="dealer-rating" opinions={dealer.opinions} />
                </div>

                <div className="dealer-info__header-message">
                    <Icon className="info-icon" name="info" color="primary" />
                    {badges.promoText ?? 'Kupuj taniej dzięki skapiec.pl'}
                </div>

                <div className="dealer-info__header-badges">
                    <DealerBadges badges={badges} dealerBadge={dealer.badge} authorizedConfig={dealer.producer?.config.badges.authorized} />
                </div>
            </div>

            <div className="dealer-info__info">
                <section className="dealer-info__info-column dealer-opinion-details">
                    <h3 className="dealer-info__info-column-header">Szczegółowa ocena sklepu</h3>
                    {dealer.opinions?.count
                        ? <ul className="dealer-info__info-column-details" id="dealer-opinion-details">
                            <li>Szybkość realizacji zamówienia: <strong>{dealer.opinions?.details.realizationSpeed}</strong></li>
                            <li>Poziom obsługi klienta: <strong>{dealer.opinions?.details.serviceQuality}</strong></li>
                            <li>Jakośc zapakowaniej przyesyłki: <strong>{dealer.opinions?.details.packageQuality}</strong></li>
                            <li>Polecił(a)bym ten sklep znajomym: <strong>{dealer.opinions?.details.recomendationLevel}</strong> </li>
                        </ul>
                        : <span className="dealer-info__info-column-details" >Brak opinii</span>
                    }
                </section>
                <section className="dealer-info__info-column dealer-delivery-details">
                    <h3 className="dealer-info__info-column-header">Opcje dostawy</h3>
                    <ul className="dealer-info__info-column-details" id="dealer-delivery-details">
                        {badges.delivery24 && <li>Dostawa tego samego dnia</li>}
                        {badges.freeDelivery && <li>Darmowa wysyłka</li>}
                        {badges.inPost && <li>Wysyłka z inPost</li>}
                        {!badges.delivery24 && !badges.freeDelivery && !badges.inPost && 'Sprawdź w sklepie'}
                    </ul>
                </section>
                <section className="dealer-info__info-column dealer-aviability-details">
                    <h3 className="dealer-info__info-column-header">Czas dostawy</h3>
                    <ul className="dealer-info__info-column-details" id="dealer-aviability-details">
                        {badges.delivery24 && <li>Zwykle w ciagu 24 godzin</li>}
                        {!badges.delivery24 && <li>Sprawdź w sklepie</li>}
                    </ul>
                </section>
                <section className="dealer-info__info-column dealer-payments-details">
                    <h3 className="dealer-info__info-column-header">Płatności</h3>
                    <ul className="dealer-info__info-column-details" id="dealer-payments-details">
                        {badges.fastPayment && <li>Szybkie płatności</li>}
                        {rates && <li>Zakupy na raty {isProductRateZero(title) ? ' 0%' : ''}</li>}
                        {!badges.fastPayment && !rates && 'Sprawdź w sklepie'}
                    </ul>
                </section>
            </div>
        </div >
    );
};

export default OfferDealerInfo;
